/* eslint-disable eqeqeq */
import React from 'react';
import { container } from 'tsyringe';
import { PengajuanPelatihanPresenter } from '../../../../../../../data/presenters/PengajuanPelatihanPresenter';
import { toast } from 'react-toastify';
import history from '../../../../../../../history';
import moment from 'moment';
import axiosInstance from '../../../../../../api/axiosInstance';
import { JenisPelatihanPresenter } from '../../../../../../../data/presenters/JenisPelatihanPresenter';
import { MenuJenisPelatihanPresenter } from '../../../../../../../data/presenters/MenuJenisPelatihanPresenter';
import { JenisPelatihan } from '../../../../../../../entities/JenisPelatihan';
import { SubMenuJenisPelatihan } from '../../../../../../../entities/MenuJenisPelatihan';

type OptionType = {
  value: string;
  label: string;
};
interface IState {
  isLoading: boolean;
  path_thumbnail: any;
  jenis_pelatihan_id: number;
  sub_menu_jenis_pelatihan_id: number;
  waktu_mulai: string;
  waktu_selesai: string;
  waktu_mulai_pendaftaran: string;
  waktu_selesai_pendaftaran: string;
  penyelenggara: string;
  informasi_umum: string;
  kompetensi_teknis: string;
  persyaratan: string;
  angkatan: string;
  jenisPelatihan: JenisPelatihan[];
  subMenuJenisPelatihan: SubMenuJenisPelatihan[];
  msgError: any[];
  isPPKB: boolean;
  materiInti: string;
  eventId: string;
  isPretest: boolean;
  isForGuruMadrasah: boolean;
  isCustomJenisPenilaian: boolean;
  jenis_penilaian_id: string;
  listOptionsJenisPenilaian: OptionType[];
  jenisPenilaianSelected: OptionType | null;
  judulPelatihan: string;
  linkEvaluasi: string;
  accessLinkEvaluasi: boolean;
  logoPenyelenggara: any;
}

interface InitialState {
  state: IState;
  createPengajuanPelatihan: Function;
  setPathThumbnail: Function;
  setJenisPelatihanId: Function;
  setSubMenuJenisPelatihanId: Function;
  setWaktuMulai: Function;
  setWaktuSelesai: Function;
  setWaktuMulaiPendaftaran: Function;
  setWaktuSelesaiPendaftaran: Function;
  setPenyelenggara: Function;
  setInformasiUmum: Function;
  setKompetensiTeknis: Function;
  setPersyaratan: Function;
  setAngkatan: Function;
  getJenisPelatihan: Function;
  getSubMenuJenisPelatihan: Function;
  setIsPPKB: Function;
  setCreateManajemenPengajuanPelatihan: Function;
  setEventId: Function;
  setIsPretest: Function;
  getJenisPenilaian: Function;
  setJenisPenilaian: Function;
  setJudulPelatihan: Function;
  setLinkEvaluasi: Function;
  setAccessLinkEvaluasi: Function;
  setLogoPenyelenggara: Function;
}

const initialState = {
  state: {
    isLoading: false,
    path_thumbnail: null,
    jenis_pelatihan_id: 0,
    sub_menu_jenis_pelatihan_id: 0,
    waktu_mulai: '',
    waktu_selesai: '',
    waktu_mulai_pendaftaran: '',
    waktu_selesai_pendaftaran: '',
    penyelenggara: '',
    informasi_umum: '',
    kompetensi_teknis: '',
    persyaratan: '',
    angkatan: '',
    jenisPelatihan: [],
    subMenuJenisPelatihan: [],
    msgError: [],
    isPPKB: false,
    materiInti: '',
    eventId: '',
    isPretest: false,
    isForGuruMadrasah: false,
    isCustomJenisPenilaian: false,
    jenis_penilaian_id: '',
    listOptionsJenisPenilaian: [],
    jenisPenilaianSelected: null,
    judulPelatihan: '',
    listAdminNonLembaga: [],
    linkEvaluasi: '',
    accessLinkEvaluasi: false,
    logoPenyelenggara: null,
  },
  createPengajuanPelatihan: () => {},
  setPathThumbnail: () => {},
  setJenisPelatihanId: () => {},
  setSubMenuJenisPelatihanId: () => {},
  setWaktuMulai: () => {},
  setWaktuSelesai: () => {},
  setWaktuMulaiPendaftaran: () => {},
  setWaktuSelesaiPendaftaran: () => {},
  setPenyelenggara: () => {},
  setInformasiUmum: () => {},
  setKompetensiTeknis: () => {},
  setPersyaratan: () => {},
  setAngkatan: () => {},
  getJenisPelatihan: () => {},
  getSubMenuJenisPelatihan: () => {},
  setIsPPKB: () => {},
  setCreateManajemenPengajuanPelatihan: () => {},
  setEventId: () => {},
  setIsPretest: () => {},
  getJenisPenilaian: () => {},
  setJenisPenilaian: () => {},
  setJudulPelatihan: () => {},
  getListAdminNonLembaga: () => {},
  setLinkEvaluasi: () => {},
  setAccessLinkEvaluasi: () => {},
  setLogoPenyelenggara: () => {},
};
const Context = React.createContext<InitialState>(initialState);
const { Provider: ManajemenPengajuanPelatihanCreateProvider } = Context;

const Provider: React.FC = ({ children }) => {
  const [state, setState] = React.useState<IState>({
    isLoading: false,
    path_thumbnail: null,
    jenis_pelatihan_id: 0,
    sub_menu_jenis_pelatihan_id: 0,
    waktu_mulai: '',
    waktu_selesai: '',
    waktu_mulai_pendaftaran: '',
    waktu_selesai_pendaftaran: '',
    penyelenggara: '',
    informasi_umum: '',
    kompetensi_teknis: '',
    persyaratan: '',
    angkatan: '',
    jenisPelatihan: [],
    subMenuJenisPelatihan: [],
    msgError: [],
    isPPKB: false,
    materiInti: '',
    eventId: '',
    isPretest: false,
    isForGuruMadrasah: false,
    isCustomJenisPenilaian: false,
    jenis_penilaian_id: '',
    listOptionsJenisPenilaian: [],
    jenisPenilaianSelected: null,
    judulPelatihan: '',
    linkEvaluasi: '',
    accessLinkEvaluasi: false,
    logoPenyelenggara: null,
  });

  const setCreateManajemenPengajuanPelatihan = <K extends keyof IState>(
    key: K,
    value: IState[K]
  ) => {
    setState((prevstate) => ({
      ...prevstate,
      [key]: value,
    }));
  };

  const setLoading = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isLoading: value,
    }));
  };

  const setIsPretest = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isPretest: value,
    }));
  };

  const setEventId = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      eventId: value,
    }));
  };

  const createPengajuanPelatihan = async () => {
    setLoading(true);

    if (
      state.path_thumbnail == null ||
      state.jenis_pelatihan_id == 0 ||
      state.sub_menu_jenis_pelatihan_id == 0 ||
      state.waktu_mulai == '' ||
      state.waktu_selesai == '' ||
      state.waktu_mulai_pendaftaran == '' ||
      state.waktu_selesai_pendaftaran == '' ||
      state.penyelenggara == '' ||
      state.informasi_umum == '' ||
      state.persyaratan == '' ||
      state.angkatan == '' ||
      state.jenisPenilaianSelected === null ||
      (state.accessLinkEvaluasi && state.linkEvaluasi == '')
    ) {
      toast('Data Belum Terisi Lengkap!');
      setLoading(false);
      return;
    }

    try {
      const pengajuanPelatihanPresenter = container.resolve(
        PengajuanPelatihanPresenter
      );

      const store = await pengajuanPelatihanPresenter.storePengajuanPelatihan(
        state.sub_menu_jenis_pelatihan_id,
        state.jenis_pelatihan_id,
        state.judulPelatihan,
        state.jenisPenilaianSelected?.value,
        moment(state.waktu_mulai_pendaftaran).format('YYYY-MM-DD HH:mm:ss'),
        moment(state.waktu_selesai_pendaftaran).format('YYYY-MM-DD HH:mm:ss'),
        moment(state.waktu_mulai).format('YYYY-MM-DD HH:mm:ss'),
        moment(state.waktu_selesai).format('YYYY-MM-DD HH:mm:ss'),
        state.penyelenggara,
        state.informasi_umum,
        state.persyaratan,
        state.angkatan,
        state.kompetensi_teknis,
        state.isPPKB,
        state.isPPKB ? state.materiInti : '',
        state.isForGuruMadrasah,
        state.path_thumbnail,
        state.linkEvaluasi,
        state.logoPenyelenggara
      );

      const data = store;

      if (data.data.code == 200) {
        toast('Berhasil Menambahkan Data Baru.');

        history.replace(
          `/admin/kelola_konten/manajemen_pengajuan_pelatihan/${data.data.data.uuid}`
        );
        window.location.reload();
      } else {
        toast('Ada Kesalahan Saat Tambah Data!');
      }
      setLoading(false);
    } catch (error: any) {
      console.log('error pengajuanPelatihan:', error);
      toast('Ada Kesalahan Saat Tambah Data!');
      if (error.response.data?.errors) {
        setState((prevstate) => ({
          ...prevstate,
          msgError: [error.response.data?.errors],
        }));
      }
      setLoading(false);
    }
  };

  const setPathThumbnail = (value) => {
    setState((prevstate) => ({
      ...prevstate,
      path_thumbnail: value,
    }));
  };

  const setJenisPelatihanId = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      jenis_pelatihan_id: value,
    }));
  };

  const setSubMenuJenisPelatihanId = (value: number) => {
    setState((prevstate) => ({
      ...prevstate,
      sub_menu_jenis_pelatihan_id: value,
    }));
  };

  const setWaktuMulai = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      waktu_mulai: value,
    }));
  };

  const setWaktuSelesai = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      waktu_selesai: value,
    }));
  };

  const setWaktuMulaiPendaftaran = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      waktu_mulai_pendaftaran: value,
    }));
  };

  const setWaktuSelesaiPendaftaran = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      waktu_selesai_pendaftaran: value,
    }));
  };

  const setPenyelenggara = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      penyelenggara: value,
    }));
  };

  const setInformasiUmum = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      informasi_umum: value,
    }));
  };

  const setKompetensiTeknis = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      kompetensi_teknis: value,
    }));
  };

  const setPersyaratan = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      persyaratan: value,
    }));
  };

  const setAngkatan = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      angkatan: value,
    }));
  };

  const setIsPPKB = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      isPPKB: value,
    }));
  };

  const setJudulPelatihan = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      judulPelatihan: value,
    }));
  };

  const getJenisPelatihan = async (sub_menu_jenis_pelatihan_id: string) => {
    try {
      const jenisPelatihan = container.resolve(JenisPelatihanPresenter);

      const get = await jenisPelatihan.getAllJenisPelatihan(
        1,
        10000000,
        '',
        sub_menu_jenis_pelatihan_id
      );

      const data = get;

      setState((prevstate) => ({
        ...prevstate,
        jenisPelatihan: data,
      }));
    } catch (error: any) {
      console.log('error get Jenis Pelatihan:', error);
    }
  };

  const getSubMenuJenisPelatihan = async () => {
    try {
      const menuJenisPelatihanPresenter = container.resolve(
        MenuJenisPelatihanPresenter
      );

      const get = await menuJenisPelatihanPresenter.getAllSubMenuJenisPelatihan(
        1,
        10000000,
        ''
      );

      const data = get;

      setState((prevstate) => ({
        ...prevstate,
        subMenuJenisPelatihan: data,
      }));
    } catch (error: any) {
      console.log('error get Sub Menu Jenis Pelatihan:', error);
    }
  };

  const setJenisPenilaian = (value: OptionType) => {
    setState((prevstate) => ({
      ...prevstate,
      jenisPenilaianSelected: value,
    }));
  };

  const getJenisPenilaian = async () => {
    try {
      const { data } = await axiosInstance.get('jenis_penilaian');
      const listJenisPenialain = data?.data.map((item) => {
        return {
          value: item.id,
          label: item.nama_jenis_penilaian,
        };
      });

      setState((prevstate) => ({
        ...prevstate,
        listOptionsJenisPenilaian: listJenisPenialain,
      }));
    } catch (error) {
      throw error;
    }
  };

  const setLinkEvaluasi = (value: string) => {
    setState((prevstate) => ({
      ...prevstate,
      linkEvaluasi: value,
    }));
  };

  const setAccessLinkEvaluasi = (value: boolean) => {
    setState((prevstate) => ({
      ...prevstate,
      accessLinkEvaluasi: value,
    }));
  };

  const setLogoPenyelenggara = (value) => {
    setState((prevstate) => ({
      ...prevstate,
      logoPenyelenggara: value,
    }));
  };

  return (
    <ManajemenPengajuanPelatihanCreateProvider
      value={{
        state,
        createPengajuanPelatihan,
        setPathThumbnail,
        setJenisPelatihanId,
        setSubMenuJenisPelatihanId,
        setWaktuMulai,
        setWaktuSelesai,
        setWaktuMulaiPendaftaran,
        setWaktuSelesaiPendaftaran,
        setPenyelenggara,
        setInformasiUmum,
        setKompetensiTeknis,
        setPersyaratan,
        setAngkatan,
        getJenisPelatihan,
        getSubMenuJenisPelatihan,
        setIsPPKB,
        setCreateManajemenPengajuanPelatihan,
        setEventId,
        setIsPretest,
        getJenisPenilaian,
        setJenisPenilaian,
        setJudulPelatihan,
        setLinkEvaluasi,
        setAccessLinkEvaluasi,
        setLogoPenyelenggara,
      }}
    >
      {children}
    </ManajemenPengajuanPelatihanCreateProvider>
  );
};

export const useManajemenPengajuanPelatihanCreateContext = () =>
  React.useContext(Context);
// eslint-disable-next-line
export default {
  useManajemenPengajuanPelatihanCreateContext,
  Provider,
};
